export enum TabNames {
    WaitingForApproval = 'Waiting for Approval',
    PaymentPending = 'Payment Pending',
    PaymentCollection = 'Payment Collection',
    Rejected = 'Rejected',
    Requested = 'Requested',
    Approved = 'Approved',
    InternalApprovalApproval = 'Internal Approval',
    ClientApprovalApproval = 'Client Approval',
    LandlordApprovalApproval = 'Landlord Approval',
    signed = 'Signed',
    draft = 'Draft',
  }
  export enum TabLabels {
    WaitingForApproval = 'Waiting for Approval',
    PaymentPending = 'Payment Pending',
    PaymentCollection = 'Payment Collection',
    Rejected = 'Rejected',
    Requested = 'Requested',
    Approved = 'Approved',
    Draft = 'Draft',
  }
  
  export enum InvoiceStatus {
    WaitingForApproval = 'Waiting for Approval',
    PaymentPending = 'Payment Pending',
    PaymentCollection = 'Payment Collection',
    Rejected = 'Rejected'
  }


  export enum documentStage {
    TermsheetSubmission = 'term_sheet_submission',
    FeeConfirmation = 'fee_confirmation',
    LOI = 'letter_of_intent',
    Agreement = 'agreement',
    Invoice = 'invoice',
  }